import { createUseStyles } from 'react-jss';
import glow from './images/glow.svg';

export const useStyles = createUseStyles({
  light: {
    fontSize: 2.8,
    fill: '#9B9298',
  },
  dark: {
    fontSize: 2.2,
    fill: '#ECE9EC',
  },
  horizontalNotation: {
    touchAction: 'none',
    width: '12.5%',
    height: '12.5%',
    position: 'absolute',
    backgroundSize: '100%',
    fontSize: 9,
    marginLeft: 2,
    marginBottom: 3,
    bottom: '-10%',
  },

  verticalNotation: {
    touchAction: 'none',
    height: '12.5%',
    top: 'auto',
    position: 'absolute',
    backgroundSize: '100%',
    overflow: 'hidden',
    fontSize: 9,
    marginTop: 2,
    marginLeft: 3,
    left: 0,
  },

  border: (props) => ({
    border: `${props?.borderWidth}px solid #2b2f48`,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
  }),

  hoverMobile: {
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '200%',
      height: '200%',
      backgroundColor: 'rgba(0,0,0,0.2)',
      borderRadius: '50%',
    },
  },
  hoverDesktop: {
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderRadius: '50%',
  },

  noselect: {
    '-webkit-touch-callout': 'none',
    '-webkit-user-select': 'none',
    '-khtml-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },

  square: {
    left: 0,
    touchAction: 'none',
    width: '12.5%',
    height: '12.5%',
    top: 'auto',
    position: 'absolute',
    backgroundSize: '100%',
  },

  chessboard: {
    margin: '0 auto',
    backgroundImage: `url(
      "data:image/svg+xml;base64,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"
    )`,
    backgroundSize: '100% 100%',
    borderRadius: 0,
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'no-repeat no-repeat',
    position: 'relative',
  },

  glow: {
    width: '100%',
    height: 100,
    objectFit: 'cover',
    position: 'absolute',
    left: 0,
    opacity: 0.4,
  },
});
